export const VoxelTagIDs = {
    substance: "#dve_substance",
    shapeID: "#dve_shape_id",
    material: "#dve_material",
    hardness: "#dve_hardness",
    colliderID: "#dve_collider_id",
    checkCollisions: "#dve_check_collisions",
    isLightSource: "#dve_is_light_source",
    lightValue: "#dve_light_value",
    isRich: "#dve_is_rich",
};
